// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"3dc91155","3362":"3dc91155","4382":"3dc91155","4942":"c6138624","6048":"3dc91155","7504":"3dc91155"}[chunkId] + ".chunk.css";
};